import React from 'react';
import ChartHomePage from '../ChartComponents/ChartHomePage';
import ChartData from '../ChartComponents/ChartData';
import {Route,Switch} from 'react-router-dom';
import {getInitialData} from '../../actions/index'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

var questions = {
    Intent: null,
    chart: null
};
var initialData = {
    mainData: [{
        data: questions,
        type: 'text'
    }]
};

class Chart extends React.Component{
  constructor(props){
    super(props);
    this.state={
      chart:props.chartvalues
    }
  }
  render() {
    var topStyle = {margin: '21px 0px -8px 22px'}; 
    return(
      <Switch>
        <Route exact path={`${this.props.match.url}`} render={() =>
          <ChartHomePage data={this.state.chart}/>}
        />
        <Route path={`/chart`} component={ChartData} />
      </Switch>
    )
  }
}

function mapStateToProps(state) {
  var chartvalues = state.dataSet.alfred;
  return {
    chartvalues: chartvalues,
    dataSet: state.dataSet.dataSet,
    globalFilters: state.dataSet.globalFilters
  }
}
function mapDispatchToProps(dispatch){
  return bindActionCreators({
      getInitialData 
  },dispatch)
}

export default connect(mapStateToProps,mapDispatchToProps)(Chart);